<template>
  <div>
    <div class="text-center mb-6">
      <h2 class="text-xl font-bold text-black mb-2">Verificá tus datos</h2>
      <p class="text-sm text-dark-gray">
        Para continuar con tu suscripción, necesitamos verificar tu información de contacto.
      </p>
    </div>

    <div class="space-y-4">
      <div
        :class="phoneVerified ? 'banner-success' : 'banner-warning'"
        class="rounded-xl"
      >
        <div class="flex items-start gap-3">
          <CheckCircleIcon
            v-if="phoneVerified"
            class="w-6 h-6 text-aces flex-shrink-0 mt-0.5"
          />
          <ExclamationCircleIcon
            v-else
            class="w-6 h-6 text-warning flex-shrink-0 mt-0.5"
          />
          <div class="flex-1 min-w-0">
            <div class="flex items-center justify-between gap-2">
              <span
                :class="phoneVerified ? 'text-aces' : 'text-warning-fg'"
                class="text-sm font-medium"
              >
                {{ phoneVerified ? "Teléfono verificado" : "Teléfono pendiente" }}
              </span>
            </div>
            <p class="text-black font-medium mt-1 break-all">
              {{ maskedPhone }}
            </p>
            <button
              v-if="!phoneVerified"
              type="button"
              :disabled="busy"
              class="btn-primary mt-3 text-sm disabled:opacity-60"
              @click="$emit('verify', 'phone')"
            >
              {{ busy && busyType === "phone" ? "Enviando..." : "Verificar ahora" }}
            </button>
          </div>
        </div>
      </div>

      <div
        :class="emailVerified ? 'banner-success' : 'banner-warning'"
        class="rounded-xl"
      >
        <div class="flex items-start gap-3">
          <CheckCircleIcon
            v-if="emailVerified"
            class="w-6 h-6 text-aces flex-shrink-0 mt-0.5"
          />
          <ExclamationCircleIcon
            v-else
            class="w-6 h-6 text-warning flex-shrink-0 mt-0.5"
          />
          <div class="flex-1 min-w-0">
            <div class="flex items-center justify-between gap-2">
              <span
                :class="emailVerified ? 'text-aces' : 'text-warning-fg'"
                class="text-sm font-medium"
              >
                {{ emailVerified ? "Email verificado" : "Email pendiente" }}
              </span>
            </div>
            <p class="text-black font-medium mt-1 truncate">
              {{ maskedEmail }}
            </p>
            <button
              v-if="!emailVerified"
              type="button"
              :disabled="busy"
              class="btn-primary mt-3 text-sm disabled:opacity-60"
              @click="$emit('verify', 'email')"
            >
              {{ busy && busyType === "email" ? "Enviando..." : "Verificar ahora" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <p class="text-xs text-dark-gray text-center mt-6">
      Ambos datos deben estar verificados para continuar con tu suscripción.
    </p>

    <p class="text-sm text-dark-gray text-center mt-4">
      ¿El teléfono o el email no son correctos?
      <button
        type="button"
        class="text-aces font-medium hover:underline"
        @click="$emit('edit')"
      >
        Editá tus datos
      </button>
    </p>

  </div>
</template>

<script>
  import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/solid";

  export default {
    name: "VerificationPending",
    components: { CheckCircleIcon, ExclamationCircleIcon },
    props: {
      phoneVerified: { type: Boolean, default: false },
      emailVerified: { type: Boolean, default: false },
      phoneNumber: { type: String, default: "" },
      email: { type: String, default: "" },
      busy: { type: Boolean, default: false },
      busyType: { type: String, default: "" },
    },
    emits: ["verify", "edit"],
    computed: {
      maskedPhone() {
        const p = String(this.phoneNumber || "");
        if (!p) return "—";
        if (p.length <= 4) return p;
        return "*".repeat(Math.max(0, p.length - 4)) + p.slice(-4);
      },
      maskedEmail() {
        const e = String(this.email || "");
        if (!e || !e.includes("@")) return e || "—";
        const [local, domain] = e.split("@");
        const visible = Math.min(3, local.length);
        return `${local.slice(0, visible)}***@${domain}`;
      },
    },
  };
</script>
